// Название из справочника на языке интерфейса, с откатом на второй язык
export const titleOf = (item: { titleKz?: string | null; titleRu?: string | null }, locale: string): string =>
    (locale === 'ru' ? item.titleRu : item.titleKz) || item.titleRu || item.titleKz || ''
